<template>
  <div class="device-kpi">
    <div v-for="kpi in kpis" :key="kpi.order" class="device-kpi__item" :style="`color: ${kpi.color}`">
      {{kpi.label}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceKpi',
  props: {
    kpis: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style>
  .device-kpi {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    max-height: 90px;
    flex-wrap: wrap;
  }
  .device-kpi__item {
    text-align: left;
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
  }

  @media screen and (max-width: 1500px){
    .device-kpi {
      max-height: 120px;
    }
  }

  @media screen and (max-width: 1100px){
    .device-kpi {
      max-height: none;
    }
  }
</style>